(function () {
  function animateStat(el) {
    if (el.dataset.animated === "true") return;
    el.dataset.animated = "true";

    var target = parseFloat(el.dataset.target);
    if (isNaN(target)) return;

    var prefix = el.dataset.prefix || "";
    var suffix = el.dataset.suffix || "";
    var isDecimal = target % 1 !== 0;
    var duration = 1600;
    var start = performance.now();

    function tick(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;

      if (isDecimal) {
        el.textContent = prefix + current.toFixed(1).replace(".", ",") + suffix;
      } else {
        el.textContent = prefix + Math.round(current) + suffix;
      }

      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initSection(section) {
    if (!section || section.dataset.ruHomeCienciaV2Init === "true") return;
    section.dataset.ruHomeCienciaV2Init = "true";

    var counters = section.querySelectorAll("[data-count-up]");
    if (!counters.length) return;

    if (!("IntersectionObserver" in window)) {
      counters.forEach(function (el) {
        el.textContent =
          (el.dataset.prefix || "") + el.dataset.target + (el.dataset.suffix || "");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateStat(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(".section-ru-home-ciencia-v2").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
